<template>
  <el-container>
    <el-main>
      <el-row>
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="110px"
        >
          <el-form-item
            label="试题分类"
            prop="xzstflList"
            :rules="[{ validator: validateStfl, trigger: 'change' }]"
          >
            <classify
              :value.sync="form.xzstflList"
              type="questions"
              :multiple="true"
            ></classify>
            <el-button type="primary" @click="showDialog = true"
              >选择试题分类</el-button
            >
          </el-form-item>
          <el-dialog
            title="选择试题分类"
            :visible.sync="showDialog"
            :append-to-body="true"
            width="30%"
            center
          >
            <classifyTree
              :value.sync="form.xzstflList"
              type="questions"
              :visible.sync="showDialog"
            ></classifyTree>
          </el-dialog>
          <el-form-item
            v-for="(ksySjkCtgz, index) in form.ksySjkCtgzList"
            :key="index"
            :label="ksySjkCtgz.nycdms"
            :prop="'ksySjkCtgzList.' + index + '.ctgs'"
            :rules="[{ validator: validateCtgs, trigger: 'blur' }]"
          >
            <el-input
              v-model.number="ksySjkCtgz.ctgs"
              style="width: 100px"
              type="number"
              @keypress.native="handleKeypress"
            />/{{ ksySjkCtgz.total }}
          </el-form-item>
          <el-form-item style="text-align: center; width: 500px">
            <el-button type="primary" @click="submitForm">确定</el-button>
            &nbsp;&nbsp;&nbsp;
            <el-button type="info" @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import classify from '@/components/select/classify'
import classifyTree from '@/components/tree/classifyTree'
import { getStCount, getStkListRand } from '@/api/questions'
export default {
  data () {
    return {
      showDialog: false,
      form: {
        xzstflList: [],
        ksySjkCtgzList: []
      },
      stids: ''
    }
  },
  props: {
    dtObj: Object,
    zjfs: String,
    visible: Boolean,
    allDtData: Array
  },
  components: {
    classify,
    classifyTree
  },
  watch: {
    'form.xzstflList': {
      handler (val, oldVal) {
        this.getStCount()
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    'dtObj.tx': {
      handler (val, oldVal) {
        this.getStCount()
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    // 限制只能输入数字
    handleKeypress (e) {
      const charCode = e.keyCode || e.which
      const charStr = String.fromCharCode(charCode)

      // 只允许输入数字
      if (!/^\d$/.test(charStr)) {
        e.preventDefault()
      }
    },
    validateStfl (rule, value, callback) {
      if (value === null || value.length === 0) {
        callback(new Error('试题分类不能为空'))
      } else {
        callback()
      }
    },
    validateCtgs (rule, value, callback) {
      console.log(value, 'value')
      if (value !== null && value !== '') {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字'))
        } else if (value <= 0) {
          callback(new Error('抽题个数必须大于0!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.ksySjkCtgzList) {
            this.$message.warning('至少要选择一个题目')
            return false
          }
          // 找到一个有值的试题个数框
          let ksySjkCtgzList = this.form.ksySjkCtgzList.filter(
            ksySjkCtgz => ksySjkCtgz.ctgs !== null && ksySjkCtgz.ctgs > 0
          )
          if (ksySjkCtgzList.length === 0) {
            this.$message.warning('至少要选择一个题目')
            return false
          }
          const ksySjkCtgzTemp = ksySjkCtgzList.find(
            ksySjkCtgz => ksySjkCtgz.ctgs > ksySjkCtgz.total
          )
          if (ksySjkCtgzTemp) {
            this.$message.warning(
              ksySjkCtgzTemp.nycdms +
                '难度，抽取题目个数不能大于题目总数' +
                ksySjkCtgzTemp.total
            )
            return false
          }
          // 如果是抽提组卷方式 则要把题目回显到试卷设计页面
          if (this.zjfs === '2') {
            this.getStkListRand()
          }
          // 将抽提规则回显到页面
          ksySjkCtgzList = ksySjkCtgzList.map(ksySjkCtgz => {
            ksySjkCtgz.xzstfl = this.form.xzstflList.join(',')
            Object.assign(ksySjkCtgz, {
              sjid: this.dtObj.sjid,
              dtid: this.dtObj.dtid
            })
            return ksySjkCtgz
          })
          this.$set(this.dtObj, 'ksySjkCtgzList', ksySjkCtgzList)
          // 将分类标签也返回到编辑页面
          // const flTagHtml = document.querySelector('.el-select__tags').innerHTML
          // this.$emit('appendFlTag', this.dtObj.dtid, flTagHtml)
          const flbhs = this.form.xzstflList.join(',')
          this.$emit('appendFlTag', this.dtObj.dtid, flbhs)
          this.$emit('countAll')
          this.cancel()
        } else {
          return false
        }
      })
    },
    cancel () {
      this.$emit('update:visible', false)
    },
    getSelectStids () {
      this.stids = ''
      const stids = []
      const allDtDataTx = this.allDtData.filter(dt => dt.tx === this.dtObj.tx)
      const dtObjStids = this.dtObj.ksySjkStList.map(ksySjkSt => ksySjkSt.stid)
      allDtDataTx.forEach(dt => {
        dt.ksySjkStList.forEach(ksySjkSt => {
          if (!dtObjStids.includes(ksySjkSt.stid)) {
            stids.push(ksySjkSt.stid)
          }
        })
      })
      this.stids = stids.join(',')
    },
    // 获取题目个数
    getStCount () {
      if (this.form.xzstflList === null || this.form.xzstflList.length === 0) {
        this.form.ksySjkCtgzList = []
      } else {
        const xzstfls = this.form.xzstflList.join(',')
        this.getSelectStids()
        const params = {
          tx: this.dtObj.tx,
          xzstfls: xzstfls,
          excludeStids: this.stids
        }
        getStCount(params).then(res => {
          this.$http.callback(res, () => {
            this.form.ksySjkCtgzList = res.data
            this.form.ksySjkCtgzList.forEach(ksySjkCtgz => {
              this.$set(ksySjkCtgz, 'ctgs', null) // 设置抽提个数字段
            })
          })
        })
      }
    },
    // 根据抽题规则 随机获取试题列表
    getStkListRand () {
      // 只要有填写抽题个数的
      let ksySjkCtgzList = this.form.ksySjkCtgzList.filter(
        ksySjkCtgz => ksySjkCtgz.ctgs !== null && ksySjkCtgz.ctgs !== ''
      )
      // 补充分类信息
      ksySjkCtgzList = ksySjkCtgzList.map(ksySjkCtgz => {
        ksySjkCtgz.xzstfl = this.form.xzstflList.join(',')
        return ksySjkCtgz
      })
      this.getSelectStids()
      const params = {
        tx: this.dtObj.tx,
        ksySjkCtgzList: ksySjkCtgzList,
        excludeStids: this.stids
      }
      getStkListRand(params).then(res => {
        this.$http.callback(res, () => {
          this.intoDtobj(res.data)
          this.$emit('countAll')
        })
      })
    },
    intoDtobj (stkList) {
      // 根据试题ID 获取试题对象
      const list = []
      let xsxh = 1
      stkList.forEach(stk => {
        if (stk.tx !== this.dtObj.tx) {
          this.$message.warning('试题题型不一致！')
          return
        }
        const ksySjkSt = {
          sjid: this.dtObj.sjid,
          dtid: this.dtObj.dtid,
          stid: stk.stid,
          stfz: this.dtObj.mxtfz,
          xsxh: xsxh++,
          tg: stk.tg,
          stnr: stk.stnr,
          tx: stk.tx,
          nycd: stk.nycd,
          stbb: stk.stbb,
          xtgs: stk.xtgs,
          ksySjkZhtList: stk.ksyStkZhtList,
          ksySjkStxxList: stk.ksyStkStxxList,
          ksySjkStda: stk.ksyStkStda
        }
        // 增加一个'考生答案'虚拟字段
        let ksda = null
        if (ksySjkSt.ksySjkStda) {
          if (ksySjkSt.tx === '2' || ksySjkSt.tx === '3') {
            ksda = ksySjkSt.ksySjkStda.bzda
              ? ksySjkSt.ksySjkStda.bzda.split('€')
              : null
          } else {
            ksda = ksySjkSt.ksySjkStda.bzda
          }
        }
        this.$set(ksySjkSt.ksySjkStda, 'ksda', ksda)
        if (ksySjkSt.ksySjkZhtList) {
          ksySjkSt.ksySjkZhtList.forEach(ksySjkZht => {
            if (ksySjkZht.tx === '2' || ksySjkSt.tx === '3') {
              ksda = ksySjkZht.ksySjkStda.bzda.split('€')
            } else {
              ksda = ksySjkZht.ksySjkStda.bzda
            }
            this.$set(ksySjkZht.ksySjkStda, 'ksda', ksda)
          })
        }
        list.push(ksySjkSt)
      })
      this.dtObj.ksySjkStList = list
    }
  },
  created () {}
}
</script>
<style scoped>
.formItem {
  margin-left: 10px;
}
</style>
